import { render, staticRenderFns } from "./user_event.vue?vue&type=template&id=d04982a0&scoped=true"
import script from "./user_event.vue?vue&type=script&lang=js"
export * from "./user_event.vue?vue&type=script&lang=js"
import style0 from "./user_event.vue?vue&type=style&index=0&id=d04982a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04982a0",
  null
  
)

export default component.exports